import React from 'react';
import { IconBell, IconRefresh } from '@tabler/icons-react';
import Button from '../../../../../components/ui/Button';
import { NotificationGroup } from './NotificationGroup';

export const NotificationList = ({
    loading,
    combinedNotifications,
    groupedNotifications,
    hasMore,
    isLoadingMore,
    handleLoadMore,
    userCache,
    selectionMode,
    selectedIds,
    processingIds,
    openMenuId,
    currentUser,
    navigate,
    toggleSelected,
    handleNotificationClick,
    handleMarkRead,
    handleDeleteNotification,
    handleFollowRequestAccept,
    handleFollowRequestReject,
    handleAccept,
    handleDecline,
    toggleMenu
}) => {
    const dateGroupOrder = ['Today', 'Yesterday', 'This Week', 'This Month', 'Older'];

    if (loading && combinedNotifications.length === 0) {
        return (
            <div className="loading">
                <IconRefresh size={24} className="loading-icon" />
                Loading notifications...
            </div>
        );
    }

    return (
        <div className="notifications-list">
            {combinedNotifications.length === 0 ? (
                <div className="no-notifications">
                    <IconBell size={48} className="no-notifications-icon" />
                    <h3>No notifications yet</h3>
                    <p>When someone interacts with your content, you'll see it here.</p>
                </div>
            ) : (
                <>
                    {dateGroupOrder.map(group => {
                        const notifications = groupedNotifications[group];
                        if (!notifications || notifications.length === 0) return null;
                        return (
                            <NotificationGroup
                                key={group}
                                groupName={group}
                                notifications={notifications}
                                userCache={userCache}
                                selectionMode={selectionMode}
                                selectedIds={selectedIds}
                                processingIds={processingIds}
                                openMenuId={openMenuId}
                                currentUser={currentUser}
                                navigate={navigate}
                                toggleSelected={toggleSelected}
                                handleNotificationClick={handleNotificationClick}
                                handleMarkRead={handleMarkRead}
                                handleDeleteNotification={handleDeleteNotification}
                                handleFollowRequestAccept={handleFollowRequestAccept}
                                handleFollowRequestReject={handleFollowRequestReject}
                                handleAccept={handleAccept}
                                handleDecline={handleDecline}
                                toggleMenu={toggleMenu}
                            />
                        );
                    })}
                    {hasMore && (
                        <div className="load-more-container">
                            <Button
                                variant="secondary"
                                onClick={handleLoadMore}
                                disabled={isLoadingMore}
                                loading={isLoadingMore}
                                className="rounded-full px-8"
                            >
                                Load more notifications
                            </Button>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};
